import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA, PER_PAGE } from '@/plugins/vuex-async-pagginate';

class PhoneListServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params = {}) {
    return this.getList({ params: { [PER_PAGE]: 500, ...params } }).then(res => res[DATA]);
  }
}

export const PhoneListService = new PhoneListServiceClass({
  api_version: 2,
  resource: 'pbx/phone-lists'
});
